module.exports = __webpack_public_path__ + "img/menu-sendfile.3b503387.png";